import {toReadable} from 'shared/utils/number';
import {clear as init} from '../clear';

export function fromNumber(value: number): KeyboardState {
  return value > 0 ? [...toReadable(value).split('')] : init();
}
